// cache pour éviter les find répétés sur le même tableau
let matchesCache = null;
let matchesMap = null;

const buildMatchesMap = (matches) => {
  const map = new Map();
  for (const d of matches) {
    map.set(d.id, d);
  }
  return map;
};

export const getMatchesByDate = (dateId, matches) => {
  // reconstruire la Map seulement si les matches ont changé
  if (matches !== matchesCache) {
    matchesCache = matches;
    matchesMap = buildMatchesMap(matches);
  }

  const dateData = matchesMap.get(dateId);
  const loading = !dateData;
  return {
    loading,
    matches: loading ? [] : dateData.dayMatches
  };
};
